const DAILY_PUZZLE_START_DATE = '2026-06-11';
const DAILY_PUZZLE_COUNT = 100;
const TECH_LARP_TITLE = 'Tech Larp';

const group = (category, words) => ({ category, words });
const dailyGroup = (level, category, words) => ({ level, category, words });

const YELLOW_GROUPS = [
  group('GIT OPERATIONS', ['COMMIT', 'MERGE', 'REBASE', 'CHERRY-PICK']),
  group('HTTP METHODS', ['GET', 'POST', 'PUT', 'PATCH']),
  group('SQL COMMANDS', ['SELECT', 'INSERT', 'UPDATE', 'DELETE']),
  group('DEPLOY ENVIRONMENTS', ['LOCAL', 'STAGING', 'PREVIEW', 'PRODUCTION']),
  group('CONFIG FILE EXTENSIONS', ['JSON', 'YAML', 'TOML', 'ENV']),
  group('TERMINAL EDITORS', ['VIM', 'EMACS', 'NANO', 'MICRO']),
  group('PROGRAMMING PARADIGMS', ['FUNCTIONAL', 'PROCEDURAL', 'DECLARATIVE', 'REACTIVE']),
  group('DATA STRUCTURES', ['ARRAY', 'STACK', 'QUEUE', 'TREE']),
  group('BIG-O CLASSES', ['CONSTANT', 'LINEAR', 'LOGARITHMIC', 'QUADRATIC']),
  group('CLOUD PROVIDERS', ['AWS', 'AZURE', 'GCP', 'ORACLE']),
  group('AWS SERVICES', ['S3', 'LAMBDA', 'EC2', 'RDS']),
  group('PACKAGE SCRIPT VERBS', ['INSTALL', 'RUN', 'BUILD', 'TEST']),
  group('PULL REQUEST STATES', ['OPEN', 'DRAFT', 'MERGED', 'CLOSED']),
  group('CSS DISPLAY VALUES', ['BLOCK', 'INLINE', 'FLEX', 'GRID']),
  group('HTML TAGS', ['DIV', 'SPAN', 'BUTTON', 'FORM']),
  group('LEETCODE CLASSICS', ['TWO SUM', 'LRU CACHE', 'WORD LADDER', 'VALID ANAGRAM']),
  group('VERSION BUMP TYPES', ['MAJOR', 'MINOR', 'PATCH', 'PRERELEASE']),
  group('NPM SCRIPTS', ['START', 'BUILD', 'TEST', 'LINT']),
  group('LOG LEVELS', ['DEBUG', 'INFO', 'WARN', 'ERROR']),
  group('KEYBOARD MODIFIERS', ['SHIFT', 'CONTROL', 'OPTION', 'COMMAND']),
  group('REACT HOOKS AFTER USE', ['STATE', 'EFFECT', 'MEMO', 'REF']),
  group('KUBERNETES OBJECTS', ['POD', 'NODE', 'SERVICE', 'INGRESS']),
  group('DOCKER COMMANDS', ['BUILD', 'RUN', 'PULL', 'PUSH']),
  group('OBSERVABILITY SIGNALS', ['LOGS', 'METRICS', 'TRACES', 'EVENTS']),
  group('TEST TYPES', ['UNIT', 'INTEGRATION', 'E2E', 'SNAPSHOT']),
  group('AI CHAT ROLES', ['SYSTEM', 'USER', 'ASSISTANT', 'TOOL']),
  group('PITCH DECK SLIDES', ['PROBLEM', 'SOLUTION', 'MARKET', 'TRACTION']),
  group('STARTUP ROUNDS', ['PRE-SEED', 'SEED', 'SERIES A', 'BRIDGE']),
  group('SHELL COMMANDS', ['CD', 'LS', 'CP', 'MV']),
  group('CI STATUSES', ['QUEUED', 'BUILDING', 'PASSING', 'FAILING']),
  group('SEMVER RANGE SYNTAX', ['CARET', 'TILDE', 'X-RANGE', 'HYPHEN']),
  group('COMMON PORTS', ['80', '443', '3000', '5432']),
  group('BROWSER BUTTONS', ['BACK', 'FORWARD', 'RELOAD', 'BOOKMARK']),
  group('DATABASE ACTIONS', ['CREATE', 'READ', 'UPDATE', 'DELETE']),
  group('AUTH FLOWS', ['LOGIN', 'LOGOUT', 'SIGNUP', 'RESET']),
  group('SHELL I/O TERMS', ['STDIN', 'STDOUT', 'STDERR', 'PIPE']),
];

const GREEN_GROUPS = [
  group('PACKAGE MANAGERS WITH EVERYDAY MEANINGS', ['PIP', 'BREW', 'CARGO', 'YARN']),
  group('FOUNDER ARCHETYPES', ['HUSTLER', 'HACKER', 'DESIGNER', 'OPERATOR']),
  group('SAAS METRICS', ['CAC', 'LTV', 'ARR', 'MRR']),
  group('CAP TABLE INSTRUMENTS', ['SAFE', 'NOTE', 'WARRANT', 'OPTION']),
  group('DATABASE INDEX TYPES', ['BTREE', 'HASH', 'GIN', 'BRIN']),
  group('VERCEL DEPLOYMENT STATES', ['QUEUED', 'BUILDING', 'READY', 'ERROR']),
  group('GIT BRANCH STATES', ['CLEAN', 'DIRTY', 'DETACHED', 'AHEAD']),
  group('KUBERNETES CONTROLLERS', ['DEPLOYMENT', 'DAEMONSET', 'STATEFULSET', 'JOB']),
  group('AWS DATABASES', ['DYNAMODB', 'AURORA', 'REDSHIFT', 'NEPTUNE']),
  group('AWS COMPUTE SERVICES', ['EC2', 'LAMBDA', 'FARGATE', 'LIGHTSAIL']),
  group('GCP PRODUCTS', ['BIGQUERY', 'CLOUD RUN', 'FIRESTORE', 'PUB/SUB']),
  group('LINUX FILE PERMISSIONS', ['READ', 'WRITE', 'EXECUTE', 'STICKY']),
  group('NPM PACKAGES', ['REACT', 'EXPRESS', 'LODASH', 'ZOD']),
  group('PYTHON PACKAGES', ['NUMPY', 'PANDAS', 'FASTAPI', 'PYTORCH']),
  group('MAC DEV INSTALL TOOLS', ['HOMEBREW', 'MAS', 'NIX', 'ASDF']),
  group('SAN FRANCISCO TOWERS', ['COIT', 'SUTRO', 'SALESFORCE', 'TRANSAMERICA']),
  group('TECH MASCOTS / AVATARS', ['SNOO', 'OCTOCAT', 'TUX', 'DUKE']),
  group('TOP CS SCHOOLS', ['MIT', 'STANFORD', 'BERKELEY', 'CARNEGIE MELLON']),
  group('TOP CS SCHOOL MASCOTS / NICKNAMES', ['BEAVER', 'CARDINAL', 'GOLDEN BEAR', 'TARTAN']),
  group('FAMOUS SOFTWARE CREATORS', ['LINUS', 'GUIDO', 'MATZ', 'RICH HICKEY']),
  group('OPEN SOURCE LICENSES', ['MIT', 'APACHE', 'GPL', 'BSD']),
  group('DATABASES', ['POSTGRES', 'MYSQL', 'SQLITE', 'MONGODB']),
  group('MESSAGE QUEUES', ['KAFKA', 'RABBITMQ', 'SQS', 'NATS']),
  group('CACHE SYSTEMS', ['REDIS', 'MEMCACHED', 'VARNISH', 'NGINX']),
  group('TEXT EDITOR MODES', ['NORMAL', 'INSERT', 'VISUAL', 'COMMAND']),
  group('SHELLS', ['BASH', 'ZSH', 'FISH', 'POWERSHELL']),
  group('CLOUD BILL LINE ITEMS', ['COMPUTE', 'STORAGE', 'EGRESS', 'SUPPORT']),
  group('PITCH DECK SECTIONS', ['TEAM', 'PRODUCT', 'MARKET', 'ASK']),
  group('AI EVAL TERMS', ['BENCHMARK', 'RUBRIC', 'GOLDEN SET', 'HUMAN EVAL']),
  group('MODEL SETTINGS', ['TEMPERATURE', 'TOP P', 'MAX TOKENS', 'STOP SEQUENCE']),
  group('FOUNDATION MODEL FAMILIES', ['GPT', 'CLAUDE', 'GEMINI', 'LLAMA']),
  group('SF NEIGHBORHOODS', ['SOMA', 'MISSION', 'HAYES VALLEY', 'DOGPATCH']),
  group('MATCHA ORDER MODIFIERS', ['ICED', 'OAT', 'CEREMONIAL', 'UNSWEETENED']),
  group('VC TERMS', ['PRO RATA', 'DILUTION', 'DRAG-ALONG', 'PREFERENCE']),
  group('SECURITY ACRONYMS', ['MFA', 'SSO', 'RBAC', 'SOC2']),
  group('HTTP HEADERS', ['ACCEPT', 'COOKIE', 'REFERER', 'USER-AGENT']),
  group('CDN VENDORS', ['CLOUDFLARE', 'FASTLY', 'AKAMAI', 'VERCEL']),
];

const BLUE_GROUPS = [
  group('AI CODING PRODUCTS', ['CURSOR', 'CLAUDE CODE', 'CODEX', 'LOVABLE']),
  group('LEETCODE HARD TITLES', ['N-QUEENS', 'EDIT DISTANCE', 'WORD LADDER', 'TRAPPING RAIN WATER']),
  group('FAMOUS COMPUTER SCIENTISTS', ['DIJKSTRA', 'KNUTH', 'HOPCROFT', 'TARJAN']),
  group('LANGUAGE CREATORS', ['GUIDO VAN ROSSUM', 'BRENDAN EICH', 'BJARNE STROUSTRUP', 'JAMES GOSLING']),
  group('UNIX FOUNDERS / AUTHORS', ['KEN THOMPSON', 'DENNIS RITCHIE', 'BRIAN KERNIGHAN', 'DOUG MCILROY']),
  group('LINUX DISTRO FAMILIES', ['DEBIAN', 'RED HAT', 'SLACKWARE', 'ARCH']),
  group('AWS STORAGE SERVICES', ['S3', 'EBS', 'EFS', 'GLACIER']),
  group('KUBERNETES SIGS', ['APPS', 'NODE', 'NETWORK', 'STORAGE']),
  group('FAMOUS CS COURSE NUMBERS', ['CS 61A', '6.006', 'CS 106B', '15-112']),
  group('JAVASCRIPT META-FRAMEWORKS', ['NEXT', 'NUXT', 'SVELTEKIT', 'REMIX']),
  group('REACT RENDERING CONCEPTS', ['SERVER COMPONENTS', 'SERVER ACTIONS', 'SUSPENSE', 'HYDRATION']),
  group('INFAMOUS BUG NAMES', ['HEARTBLEED', 'SHELLSHOCK', 'LOG4SHELL', 'GHOST']),
  group('DATABASE ISOLATION LEVELS', ['READ UNCOMMITTED', 'READ COMMITTED', 'REPEATABLE READ', 'SERIALIZABLE']),
  group('CONSENSUS ALGORITHMS', ['RAFT', 'PAXOS', 'PBFT', 'ZAB']),
  group('SORTING ALGORITHMS', ['QUICKSORT', 'MERGESORT', 'HEAPSORT', 'TIMSORT']),
  group('GRAPH ALGORITHMS', ['DIJKSTRA', 'BELLMAN-FORD', 'FLOYD-WARSHALL', 'A STAR']),
  group('CACHE POLICIES', ['LRU', 'LFU', 'FIFO', 'ARC']),
  group('COMPILER PHASES', ['LEXING', 'PARSING', 'TYPECHECKING', 'CODEGEN']),
  group('RUST CORE TERMS', ['BORROW', 'LIFETIME', 'OWNERSHIP', 'TRAIT']),
  group('GO CONCURRENCY TERMS', ['GOROUTINE', 'CHANNEL', 'SELECT', 'DEFER']),
  group('PYTHON PACKAGING FILES', ['PYPROJECT', 'SETUP CFG', 'REQUIREMENTS', 'PIPFILE']),
  group('NODE-ADJACENT RUNTIMES', ['NODE', 'DENO', 'BUN', 'ELECTRON']),
  group('BROWSER ENGINES', ['BLINK', 'WEBKIT', 'GECKO', 'SERVO']),
  group('RFC KEYWORDS', ['MUST', 'SHOULD', 'MAY', 'SHALL']),
  group('AI AGENT LOOP STEPS', ['PLAN', 'ACT', 'OBSERVE', 'REFLECT']),
  group('VECTOR DATABASES', ['PINECONE', 'WEAVIATE', 'MILVUS', 'CHROMA']),
  group('OBSERVABILITY VENDORS', ['DATADOG', 'NEW RELIC', 'HONEYCOMB', 'SENTRY']),
  group('OPEN-SOURCE MASCOTS', ['GOPHER', 'FERRIS', 'DUKE', 'TUX']),
  group('ANDROID DESSERT RELEASES', ['CUPCAKE', 'DONUT', 'ECLAIR', 'FROYO']),
  group('NEOVIM DISTRIBUTIONS', ['LAZYVIM', 'ASTROVIM', 'NVCHAD', 'LUNARVIM']),
  group('CLOUDFLARE PRODUCTS', ['WORKERS', 'PAGES', 'R2', 'DURABLE OBJECTS']),
  group('VERCEL PRODUCTS', ['FUNCTIONS', 'EDGE CONFIG', 'BLOB', 'FLUID COMPUTE']),
  group('COMPUTING PIONEERS', ['JOHN MCCARTHY', 'ALAN KAY', 'GRACE HOPPER', 'BARBARA LISKOV']),
  group('DISTRIBUTED SYSTEMS TERMS', ['SHARD', 'REPLICA', 'QUORUM', 'LEASE']),
  group('CRYPTOGRAPHIC HASHES', ['SHA-256', 'BLAKE3', 'MD5', 'ARGON2']),
  group('DATABASE TREE STRUCTURES', ['B-TREE', 'LSM TREE', 'R-TREE', 'TRIE']),
  group('AI INFRA / FRAMEWORKS', ['RAY', 'TRITON', 'VLLM', 'LANGCHAIN']),
  group('MAC VIRTUALIZATION TOOLS', ['LIMA', 'COLIMA', 'UTM', 'ORBSTACK']),
];

const PURPLE_GROUPS = [
  group('UNIX COMMANDS, SOUNDED OUT', ['SEA DEE', 'ELL ESS', 'PEA ESS', 'WHO AM I']),
  group('OPENAI COFOUNDERS, PHONETICALLY', ['ALT MAN', 'BROCK MAN', 'E-LAWN', 'ILL YA']),
  group('___OPS PREFIXES', ['DEV', 'SEC', 'ML', 'REV']),
  group('___BASE', ['CODE', 'USER', 'DATA', 'KNOWLEDGE']),
  group('SEED ___', ['ROUND', 'PHRASE', 'FUNDING', 'STAGE']),
  group('___SCRIPT LANGUAGES', ['JAVA', 'TYPE', 'COFFEE', 'ACTION']),
  group('___CHAIN', ['BLOCK', 'SUPPLY', 'TOOL', 'VALUE']),
  group('CAN PRECEDE SDK', ['ANDROID', 'IOS', 'AWS', 'CUDA']),
  group('AWS SERVICES, SOUNDED OUT', ['ESS THREE', 'E C TWO', 'ARE DEE ESS', 'I AM']),
  group('___ MODE', ['FOUNDER', 'DARK', 'GOD', 'VIBE']),
  group('CAN PRECEDE AGENT', ['USER', 'BROWSER', 'CODING', 'SUPPORT']),
  group('CAN PRECEDE STACK', ['FULL', 'MEAN', 'LAMP', 'MERN']),
  group('___FLOW', ['TENSOR', 'WEB', 'CASH', 'WORK']),
  group('___DB', ['MONGO', 'COUCH', 'DYNAMO', 'DUCK']),
  group('___WARE', ['MAL', 'FIRM', 'HARD', 'SOFT']),
  group('___ PR', ['DRAFT', 'STACKED', 'SMALL', 'HOTFIX']),
  group('CAN FOLLOW ZERO', ['SHOT', 'TRUST', 'DAY', 'KNOWLEDGE']),
  group('___ MAXXING', ['VIBE', 'SPEED', 'PROMPT', 'FRONTEND']),
  group('___ PILLED', ['TECH', 'AI', 'MATCHA', 'VIM']),
  group('CAN PRECEDE MODEL', ['BUSINESS', 'LANGUAGE', 'FOUNDATION', 'DIFFUSION']),
  group('___ GRAPH', ['SOCIAL', 'KNOWLEDGE', 'CALL', 'SCENE']),
  group('___ STORE', ['APP', 'VECTOR', 'KEY', 'OBJECT']),
  group('CAN FOLLOW PIP', ['INSTALL', 'FREEZE', 'LIST', 'SHOW']),
  group('___ RUN', ['DRY', 'CLOUD', 'BUN', 'TEST']),
  group('TECH WORDS AFTER HOT', ['FIX', 'RELOAD', 'PATH', 'SWAP']),
  group('___ REQUEST', ['PULL', 'FEATURE', 'MERGE', 'SUPPORT']),
  group('CAN PRECEDE TOKEN', ['ACCESS', 'REFRESH', 'SESSION', 'BEARER']),
  group('___ FIRST', ['MOBILE', 'API', 'REMOTE', 'PRODUCT']),
  group('CAN FOLLOW NATIVE', ['APP', 'MODULE', 'BINARY', 'EXTENSION']),
  group('CAN PRECEDE KIT', ['STARTER', 'DEV', 'PRESS', 'UI']),
  group('TECH LEADER SURNAMES THAT ARE COMMON NOUNS', ['COOK', 'JOBS', 'PAGE', 'GATES']),
  group('TECH COMPANIES THAT ARE COMMON NOUNS', ['STRIPE', 'SQUARE', 'BOX', 'SNOWFLAKE']),
  group('CAN FOLLOW DARK', ['MODE', 'LAUNCH', 'POOL', 'PATTERN']),
  group('___ LOCK', ['SPIN', 'FILE', 'ROW', 'DISTRIBUTED']),
  group('___ MAP', ['ROAD', 'SITE', 'SOURCE', 'HEAT']),
  group('___ ROOM', ['WAR', 'BREAKOUT', 'DATA', 'CLEAN']),
  group('CAN PRECEDE CLOUD', ['PRIVATE', 'PUBLIC', 'HYBRID', 'EDGE']),
  group('___ LAYER', ['DATA', 'PRESENTATION', 'NETWORK', 'APPLICATION']),
  group('___ DEBT', ['TECH', 'DESIGN', 'PROCESS', 'DOCUMENTATION']),
];

const EDITORIAL_DAILY_GROUPS = {
  '2026-06-21': [
    dailyGroup('yellow', 'AWS SERVICES WITH NON-CLOUD MEANINGS', ['LAMBDA', 'GLACIER', 'AURORA', 'NEPTUNE']),
    dailyGroup('green', 'TECH COMPANIES THAT ARE COMMON NOUNS', ['STRIPE', 'SQUARE', 'BOX', 'SNOWFLAKE']),
    dailyGroup('blue', 'BIG TECH STOCK TICKERS', ['AAPL', 'META', 'NFLX', 'NVDA']),
    dailyGroup('purple', 'CAN FOLLOW ZERO', ['SHOT', 'TRUST', 'DAY', 'KNOWLEDGE']),
  ],
  '2026-06-22': [
    dailyGroup('yellow', 'LOG LEVELS', ['DEBUG', 'INFO', 'WARN', 'ERROR']),
    dailyGroup('green', 'HTTP CACHE DIRECTIVES', ['NO-CACHE', 'NO-STORE', 'MAX-AGE', 'MUST-REVALIDATE']),
    dailyGroup('blue', 'DATABASE ISOLATION LEVELS', ['READ UNCOMMITTED', 'READ COMMITTED', 'REPEATABLE READ', 'SERIALIZABLE']),
    dailyGroup('purple', 'CAN PRECEDE LOG', ['CHANGE', 'COMMIT', 'ACCESS', 'AUDIT']),
  ],
  '2026-06-23': [
    dailyGroup('yellow', 'AI CHAT ROLES', ['SYSTEM', 'USER', 'ASSISTANT', 'TOOL']),
    dailyGroup('green', 'SECURITY ACRONYMS', ['MFA', 'SSO', 'RBAC', 'SOC2']),
    dailyGroup('blue', 'SAAS METRICS', ['CAC', 'LTV', 'ARR', 'MRR']),
    dailyGroup('purple', 'CAN PRECEDE TOKEN', ['ACCESS', 'REFRESH', 'SESSION', 'BEARER']),
  ],
  '2026-06-24': [
    dailyGroup('yellow', 'PACKAGE MANAGERS WITH EVERYDAY MEANINGS', ['PIP', 'BREW', 'CARGO', 'YARN']),
    dailyGroup('green', 'MAC DEV INSTALL TOOLS', ['HOMEBREW', 'MAS', 'NIX', 'ASDF']),
    dailyGroup('blue', 'PYTHON PACKAGING FILES', ['PYPROJECT', 'SETUP CFG', 'REQUIREMENTS', 'PIPFILE']),
    dailyGroup('purple', 'CAN FOLLOW PIP', ['INSTALL', 'FREEZE', 'LIST', 'SHOW']),
  ],
  '2026-06-25': [
    dailyGroup('yellow', 'CLOUD PROVIDERS', ['AWS', 'AZURE', 'GCP', 'ORACLE']),
    dailyGroup('green', 'AWS DATABASES', ['DYNAMODB', 'AURORA', 'REDSHIFT', 'NEPTUNE']),
    dailyGroup('blue', 'CLOUDFLARE PRODUCTS', ['WORKERS', 'PAGES', 'R2', 'DURABLE OBJECTS']),
    dailyGroup('purple', '___DB', ['MONGO', 'COUCH', 'DYNAMO', 'DUCK']),
  ],
  '2026-06-26': [
    dailyGroup('yellow', 'DATA STRUCTURES', ['ARRAY', 'STACK', 'QUEUE', 'TREE']),
    dailyGroup('green', 'TOP CS SCHOOLS', ['MIT', 'STANFORD', 'BERKELEY', 'CARNEGIE MELLON']),
    dailyGroup('blue', 'FAMOUS CS COURSE NUMBERS', ['CS 61A', '6.006', 'CS 106B', '15-112']),
    dailyGroup('purple', 'TOP CS SCHOOL MASCOTS / NICKNAMES', ['BEAVER', 'CARDINAL', 'GOLDEN BEAR', 'TARTAN']),
  ],
  '2026-06-27': [
    dailyGroup('yellow', 'FOUNDATION MODEL FAMILIES', ['GPT', 'CLAUDE', 'GEMINI', 'LLAMA']),
    dailyGroup('green', 'AI CODING PRODUCTS', ['CURSOR', 'CLAUDE CODE', 'CODEX', 'LOVABLE']),
    dailyGroup('blue', 'MODEL SETTINGS', ['TEMPERATURE', 'TOP P', 'MAX TOKENS', 'STOP SEQUENCE']),
    dailyGroup('purple', 'CAN PRECEDE MODEL', ['BUSINESS', 'LANGUAGE', 'FOUNDATION', 'DIFFUSION']),
  ],
  '2026-06-28': [
    dailyGroup('yellow', 'PULL REQUEST STATES', ['OPEN', 'DRAFT', 'MERGED', 'CLOSED']),
    dailyGroup('green', 'VERCEL DEPLOYMENT STATES', ['QUEUED', 'BUILDING', 'READY', 'ERROR']),
    dailyGroup('blue', 'VERCEL PRODUCTS', ['FUNCTIONS', 'EDGE CONFIG', 'BLOB', 'FLUID COMPUTE']),
    dailyGroup('purple', 'CAN PRECEDE CLOUD', ['PRIVATE', 'PUBLIC', 'HYBRID', 'EDGE']),
  ],
  '2026-06-29': [
    dailyGroup('yellow', 'HTML TAGS', ['DIV', 'SPAN', 'BUTTON', 'FORM']),
    dailyGroup('green', 'CSS DISPLAY VALUES', ['BLOCK', 'INLINE', 'FLEX', 'GRID']),
    dailyGroup('blue', 'BROWSER ENGINES', ['BLINK', 'WEBKIT', 'GECKO', 'SERVO']),
    dailyGroup('purple', 'BROWSER BUTTONS', ['BACK', 'FORWARD', 'RELOAD', 'BOOKMARK']),
  ],
  '2026-06-30': [
    dailyGroup('yellow', 'FOUNDER ARCHETYPES', ['HUSTLER', 'HACKER', 'DESIGNER', 'OPERATOR']),
    dailyGroup('green', 'PITCH DECK SECTIONS', ['TEAM', 'PRODUCT', 'MARKET', 'ASK']),
    dailyGroup('blue', 'TECH LEADER SURNAMES THAT ARE COMMON NOUNS', ['COOK', 'JOBS', 'PAGE', 'GATES']),
    dailyGroup('purple', '___ MODE', ['FOUNDER', 'DARK', 'GOD', 'VIBE']),
  ],
};

const normalizeSeedWord = (word) => word.trim().toUpperCase();
const CATEGORY_TOKEN_STOP_WORDS = new Set([
  'AFTER',
  'BEFORE',
  'COMMON',
  'EVERYDAY',
  'FAMOUS',
  'TERMS',
  'TYPES',
  'VALUES',
  'WITH',
  'WORDS',
]);

const getCategoryTokens = (category) => (
  category
    .split(/[^A-Z0-9]+/)
    .filter((token) => token.length > 3 && !CATEGORY_TOKEN_STOP_WORDS.has(token))
);

const formatDateFromOffset = (startDateKey, offset) => {
  const [year, month, day] = startDateKey.split('-').map(Number);
  const date = new Date(Date.UTC(year, month - 1, day + offset));
  return date.toISOString().slice(0, 10);
};

const pickNonConflictingGroup = (groups, preferredIndex, usedWords, usedCategoryTokens) => {
  let wordSafeFallback = groups[preferredIndex % groups.length];

  for (let offset = 0; offset < groups.length; offset += 1) {
    const groupCandidate = groups[(preferredIndex + offset) % groups.length];
    const hasWordConflict = groupCandidate.words.some((word) => usedWords.has(normalizeSeedWord(word)));
    const hasCategoryConflict = getCategoryTokens(groupCandidate.category)
      .some((token) => usedCategoryTokens.has(token));

    if (!hasWordConflict && wordSafeFallback === groups[preferredIndex % groups.length]) {
      wordSafeFallback = groupCandidate;
    }

    if (!hasWordConflict && !hasCategoryConflict) return groupCandidate;
  }

  return wordSafeFallback;
};

const buildDailyPuzzle = (index) => {
  const date = formatDateFromOffset(DAILY_PUZZLE_START_DATE, index);
  const editorialGroups = EDITORIAL_DAILY_GROUPS[date];

  if (editorialGroups) {
    return {
      id: `tech-larp-${date}`,
      date,
      title: TECH_LARP_TITLE,
      groups: editorialGroups,
    };
  }

  const usedWords = new Set();
  const usedCategoryTokens = new Set();
  const groupSpecs = [
    ['yellow', YELLOW_GROUPS, index],
    ['green', GREEN_GROUPS, index * 3],
    ['blue', BLUE_GROUPS, index * 5],
    ['purple', PURPLE_GROUPS, index * 7],
  ];

  const groups = groupSpecs.map(([level, groupBank, preferredIndex]) => {
    const pickedGroup = pickNonConflictingGroup(groupBank, preferredIndex, usedWords, usedCategoryTokens);
    pickedGroup.words.forEach((word) => usedWords.add(normalizeSeedWord(word)));
    getCategoryTokens(pickedGroup.category).forEach((token) => usedCategoryTokens.add(token));
    return { level, ...pickedGroup };
  });

  return {
    id: `tech-larp-${date}`,
    date,
    title: TECH_LARP_TITLE,
    groups,
  };
};

const FALLBACK_TECH_CONNECTIONS_PUZZLES = Array.from(
  { length: DAILY_PUZZLE_COUNT },
  (_, index) => buildDailyPuzzle(index),
);

const LEVEL_ORDER = ['yellow', 'green', 'blue', 'purple'];

const decodeBase64Json = (encoded) => {
  if (!encoded) return null;

  try {
    const binary = window.atob(encoded.trim());
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes));
  } catch (error) {
    return null;
  }
};

const parseJsonEnv = (rawJson) => {
  if (!rawJson) return null;

  try {
    return JSON.parse(rawJson);
  } catch (error) {
    return null;
  }
};

const getEnvPuzzles = () => {
  const base64Puzzles = decodeBase64Json(process.env.REACT_APP_TECH_CONNECTIONS_SEEDS_B64);
  if (Array.isArray(base64Puzzles)) return base64Puzzles;

  const jsonPuzzles = parseJsonEnv(process.env.REACT_APP_TECH_CONNECTIONS_SEEDS_JSON);
  if (Array.isArray(jsonPuzzles)) return jsonPuzzles;

  return null;
};

export const getTechConnectionsPuzzles = () => {
  const envPuzzles = getEnvPuzzles();
  const fallbackStartDate = FALLBACK_TECH_CONNECTIONS_PUZZLES[0]?.date;
  const fallbackEndDate = FALLBACK_TECH_CONNECTIONS_PUZZLES[FALLBACK_TECH_CONNECTIONS_PUZZLES.length - 1]?.date;
  const puzzlesByDate = new Map(FALLBACK_TECH_CONNECTIONS_PUZZLES.map((puzzle) => [puzzle.date, puzzle]));

  if (validatePuzzles(envPuzzles)) {
    envPuzzles
      .filter((puzzle) => puzzle.date >= fallbackStartDate && puzzle.date <= fallbackEndDate)
      .forEach((puzzle) => puzzlesByDate.set(puzzle.date, puzzle));
  }

  return [...puzzlesByDate.values()].sort((a, b) => a.date.localeCompare(b.date));
};

export const getLevelOrder = () => LEVEL_ORDER;

export const normalizePuzzleWord = (word) => word.trim().toUpperCase();

export const getPuzzleWords = (puzzle) => (
  puzzle.groups.flatMap((group) => group.words.map(normalizePuzzleWord))
);

export const getGroupForWords = (puzzle, words) => {
  const guessKey = words.map(normalizePuzzleWord).sort().join('|');

  return puzzle.groups.find((group) => (
    group.words.map(normalizePuzzleWord).sort().join('|') === guessKey
  ));
};

export const getAlmostMatchedGroup = (puzzle, words, solvedLevels = []) => {
  const guessedWords = new Set(words.map(normalizePuzzleWord));

  return puzzle.groups.find((group) => {
    if (solvedLevels.includes(group.level)) return false;
    const matchingWordCount = group.words.filter((word) => guessedWords.has(normalizePuzzleWord(word))).length;
    return matchingWordCount === 3;
  });
};

export const getLocalDateKey = () => {
  const timeZone = process.env.REACT_APP_TECH_CONNECTIONS_TIME_ZONE;
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    ...(timeZone ? { timeZone } : {}),
  };

  try {
    return new Intl.DateTimeFormat('en-CA', options).format(new Date());
  } catch (error) {
    return new Intl.DateTimeFormat('en-CA', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(new Date());
  }
};

export const getPuzzleForDate = (puzzles, dateKey) => {
  const exactPuzzle = puzzles.find((puzzle) => puzzle.date === dateKey);
  if (exactPuzzle) return exactPuzzle;

  const firstPuzzle = puzzles[0];
  const lastPuzzle = puzzles[puzzles.length - 1];

  if (!firstPuzzle || !lastPuzzle) return null;
  if (dateKey < firstPuzzle.date) return firstPuzzle;
  if (dateKey > lastPuzzle.date) return lastPuzzle;

  return puzzles.find((puzzle) => puzzle.date > dateKey) || firstPuzzle;
};

export const formatPuzzleDate = (dateKey) => {
  const [year, month, day] = dateKey.split('-').map(Number);
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(new Date(year, month - 1, day));
};

export const formatShortPuzzleDate = (dateKey) => {
  const [year, month, day] = dateKey.split('-').map(Number);
  return new Intl.DateTimeFormat('en-US', {
    month: 'numeric',
    day: 'numeric',
  }).format(new Date(year, month - 1, day));
};

const validatePuzzles = (puzzles) => {
  if (!Array.isArray(puzzles) || puzzles.length === 0) return false;

  return puzzles.every((puzzle) => {
    if (!puzzle.id || !puzzle.date || !Array.isArray(puzzle.groups) || puzzle.groups.length !== 4) {
      return false;
    }

    const words = puzzle.groups.flatMap((group) => group.words || []).map(normalizePuzzleWord);
    const uniqueWords = new Set(words);

    return puzzle.groups.every((group) => (
      LEVEL_ORDER.includes(group.level)
      && group.category
      && Array.isArray(group.words)
      && group.words.length === 4
    )) && words.length === 16 && uniqueWords.size === 16;
  });
};

export const getSeedSourceLabel = () => (
  validatePuzzles(getEnvPuzzles()) ? 'env' : 'fallback'
);
